<template>
  <div>

    <BreadCrumbs 
      :children="[
        {
          text: `Usuarios de lo' primo (${users.length})`,
        }
      ]"/>

    <div class="row ml-1">
      <div class="col-sm-12 text-left">
        <button class="btn mr-1 main-bg" @click="openModal" v-if="$userIsAdmin()">
          <i class="fa fa-plus"></i>
          Crear Usuario
        </button>
      </div>
    </div>

    <div class="card ml-15">
      <div class="card-body">

        <div v-if="loading" class="text-center">
          <Loader />
        </div>
        <div v-else class="table-wraper">
          <table class="table">
            <thead class="thead-light">
              <tr>
                <th>Nombre</th>
                <th>Correo</th>
                <th>Rol</th>
                <th>Estado</th>
                <th class="text-center">Opciones</th>
              </tr>  
            </thead>
            <tbody>
              <tr v-for="user in users" :key="user.id">
                <td>{{ user.name }}</td>
                <td>{{ user.id }}</td>
                <td>{{ user.roleText }}</td>
                <td><i :class="`text-${user.statusClass}`">&#9679;</i> {{ user.statusText }}</td>
                <td class="text-center">
                  <span v-if="user.loading">
                    <i class="fa fa-spinner fa-spin"></i>
                  </span>
                  <span v-else>
                    <router-link :to="`/driver/${user.id}`" class="text-primary mr-3" title="Ver detalles">
                      <i v-if="user.loading" class="fa fa-spinner fa-spin"></i>
                      <i v-else class="fa fa-eye"></i>
                    </router-link>
                  </span> 
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>

    <!-- Inicio Modal -->
    <div
      class="modal fade"
      id="user-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="roduct-modal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Crear usuario LO PRIMO</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <div class="row">
                <div class="col-sm-12">

                  <h6 class="mb-3">Datos personales</h6>

                  <div class="form-group">
                    <label for>Nombre <b class="text-danger">*</b></label>
                    <input ref="name" type="text" v-model="newDriver.name" :class="`form-control ${errors.name ? 'is-invalid' : ''}`" />
                    <small class="text-danger" v-if="errors.name">El Nombre es requerido</small>
                  </div>
                  <div class="form-group">
                    <label for>Apellido</label>
                    <input ref="last_name" type="text" v-model="newDriver.last_name" :class="`form-control ${errors.last_name ? 'is-invalid' : ''}`" />
                    <small class="text-danger" v-if="errors.last_name">El Apellido es requerido</small>
                  </div>
                  <div class="form-group">
                    <label for>Cédula <b class="text-danger">*</b></label>
                    <input ref="document_number" type="text" v-model="newDriver.document_number" :class="`form-control ${errors.document_number ? 'is-invalid' : ''}`" />
                    <small class="text-danger" v-if="errors.document_number">La Cédula es requerida</small>
                  </div>
                  <div class="form-group">
                    <label for>Teléfono <b class="text-danger">*</b></label>
                    <input ref="mobile_number" type="text" v-model="newDriver.mobile_number" :class="`form-control ${errors.mobile_number ? 'is-invalid' : ''}`" />
                    <small class="text-danger" v-if="errors.mobile_number">El Teléfono es requerido</small>
                  </div>

                  <h6 class="mt-5 mb-3">Credenciales</h6>

                  <div class="form-group">
                    <label for>Email <b class="text-danger">*</b></label>
                    <input ref="email" type="text" v-model="newDriver.email" :class="`form-control ${errors.email ? 'is-invalid' : ''}`" />
                    <small class="text-danger" v-if="errors.email">El Email es requerido</small>
                  </div>
                  <div class="form-group">
                    <label for>Clave <b class="text-danger">*</b></label>
                    <input ref="password" type="text" v-model="newDriver.password" :class="`form-control ${errors.password ? 'is-invalid' : ''}`" />
                    <small class="text-danger" v-if="errors.password">La Clave es requerida</small>
                  </div>
                </div>
              </div>

          </div>
          <div class="modal-footer">

            <div class="row" style="width:100%;">
              <div class="col-12 col-sm-6 text-left">
                <button class="btn btn-danger" :disabled="saving" @click="closeModal()">
                  <i class="fa fa-ban"></i>
                  Cancelar
                </button>
              </div>
              <div class="col-sm-6 col-12 text-right">             
                <button
                  class="btn btn-success"
                  :disabled="saving"
                  @click="saveDriver"
                >
                  <i class="fa fa-save"></i>
                  Guardar
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- Final Modal -->

  </div>
</template>

<script>
import firebase from 'firebase/app'
import BreadCrumbs from '../components/Breadcrumbs'
import Loader from '../components/Loader'
import { DriverService } from '../../services/DriverService';
import { BranchOfficeService } from '../../services/BranchOfficeService';

export default {
  name: 'LoPrimo',
  components: { BreadCrumbs,Loader },
  data:function(){
    return {
      db: firebase.firestore(),
      users: [],
      loading: false,
      name: "",
      role: '',
      loaders: {
        list: false,
      },
      inRequest: false,
      newUserIsNotAutenticated: true,
      modalOptions: {
        keyboard: false,
        backdrop: false,
      },
      thereAreUsers: true,
      companyPermissions: [],
      newPassword: "",
      saving: false,
      branchOfficeService: new BranchOfficeService(),
      companies: [],
      userCompany: '',
      driverService: new DriverService(),
      driverOrders: [],
      newDriver: {
        name: '',
        email: '',
        password: '',
        document_number: '',
        mobile_number: '',
        last_name: '',
        direction: '',
        VehicleInfo: {
          brand: '',
          color: '',
          plate: '',
          type: '',
          year: '',
        }
      },
      errors: {
        name: false,
        email: false,
        password: false,
        document_number: false,
        mobile_number: false,
      }
    }
  },
  methods: {
    async saveDriver(){
      if(!this.newDriver.name){
        this.errors.name = true;
        this.$refs.name.focus();
        return;
      }
      this.errors.name = false;

      if(!this.newDriver.document_number){
        this.errors.document_number = true;
        this.$refs.document_number.focus();
        return;
      }
      this.errors.document_number = false;

      if(!this.newDriver.mobile_number){
        this.errors.mobile_number = true;
        this.$refs.mobile_number.focus();
        return;
      }
      this.errors.mobile_number = false;

      if(!this.newDriver.email){
        this.errors.email = true;
        this.$refs.email.focus();
        return;
      }
      this.errors.email = false;

      if(!this.newDriver.password){
        this.errors.password = true;
        this.$refs.password.focus();
        return;
      }
      this.errors.password = false;
      
      this.saving = true;
      try {
        const res = await this.driverService.createDriver(this.newDriver);
        if(!res.ok){
          this.$helpers.message('Error', res.message, 'error');
        }else{
          this.$helpers.toast('Driver creado con exito');
          this.getUsers();
          this.closeModal();
        }
      } catch (error) {
        this.$helpers.message('Error', error.message, 'error');
      }
      this.saving = false;

    },
    closeModal(){
      this.newDriver = {
        name: '',
        email: '',
        password: '',
        document_number: '',
        mobile_number: '',
        last_name: '',
        direction: '',
        VehicleInfo: {
          brand: '',
          color: '',
          plate: '',
          type: '',
          year: '',
        }
      };
      this.errors = {
        name: false,
        email: false,
        password: false,
        document_number: false,
        mobile_number: false,
      };
      $("#user-modal").modal('hide');
    },
    async showOrders(user){
      console.log(user);
      const res = await this.driverService.getDriverOrders(user.id);
      
      this.driverOrders = res.orders;
      this.openModal();
      console.log(res);
    },
    async getUsers(){
      this.loading = true;
      const res = await this.driverService.getUsers();
      if(res.ok){
        this.users = res.users;
      }else{
        this.$helpers.message('Error', res.message, 'error');
      }
      this.loading = false;
    },
    openModal: function () {
      $("#user-modal").modal(this.modalOptions);
    },
  },
  beforeMount: async function() {
    const res = await this.branchOfficeService.getBranchOffices();
    if(res.ok){
      res.branchOffices.forEach(x => x['selected'] = false);
      this.companies = res.branchOffices;
      this.getUsers();
    }else{
      this.$helpers.message("Error", res.message, "error");
    }
  }
}
</script>

<style scoped>
tbody td{
  font-weight: 400;
}
.table-wraper{
  overflow-y: auto;
  max-height: 60vh;
}
.user-companies-list{
  max-height: 196px;
  overflow-y: auto;
}
</style>